/**
 * Liste-parametre for `<ReferenceInput>`-velgerne.
 *
 * BAKGRUNNEN: react-admins `ReferenceInput` henter som standard **25** rader,
 * sortert på `id`. For kundevelgeren i oppgaveskjemaet betydde det at 25 av
 * 173 kunder var synlige, i den rekkefølgen de tilfeldigvis ble opprettet —
 * altså en tilsynelatende vilkårlig håndfull, uten noe som antydet at resten
 * fantes. Søkefeltet i nedtrekket går til serveren og finner dem, men det
 * hjelper ikke den som scroller gjennom lista og konkluderer med at kunden
 * mangler.
 *
 * REGELEN: en velger skal sorteres på det brukeren leser (navnet), og hente
 * nok rader til at hele registeret får plass med god margin. Går registeret
 * forbi taket, er søket sikkerhetsnettet — men da er det *slutten* av en
 * alfabetisk liste som mangler, ikke en tilfeldig utvalgt fjerdedel.
 *
 * Takene ligger under PostgRESTs `max_rows` (1000). Vokser et register forbi
 * sitt tak, hører det hjemme her — ikke i den enkelte velgeren.
 */

/** Kunder: 173 i drift 27.08.2026. */
export const KUNDEVALG = {
  sort: { field: "name", order: "ASC" },
  perPage: 500,
} as const;

/** Kontakter: 165 i drift 27.08.2026. Sorteres på etternavn, som i lista. */
export const KONTAKTVALG = {
  sort: { field: "last_name", order: "ASC" },
  perPage: 500,
} as const;

/** Prosjekter: få per kunde, men velgerne filtreres sjelden hardt nok. */
export const PROSJEKTVALG = {
  sort: { field: "name", order: "ASC" },
  perPage: 200,
} as const;

/** Avtaler: notatskjemaet kan knytte notatet til en avtale i stedet. */
export const AVTALEVALG = {
  sort: { field: "name", order: "ASC" },
  perPage: 500,
} as const;

/** Teamet (`sales`): lite register, men det skal stå i navnerekkefølge. */
export const BRUKERVALG = {
  sort: { field: "last_name", order: "ASC" },
  perPage: 100,
} as const;
